<div class="display-table mb-3">
	<div class="row display-header">
		<div class="col align-self-center">
			<span class="title pr-2">{{title}}</span>
		</div>
	</div>

	<app-loader-wrapper [loading]="loading" class="display-body">
		<ng-container *ngIf="data">
			<div
				class="row align-items-center mx-0 p-1 bordered-top hostname"
				*ngFor="let item of data; index as i"
			>
				<div class="col">{{ dataAttr ? item[dataAttr] : item }}</div>
				<div class="col-xs-auto copy-btn">
					<button
						mat-icon-button
						type="button"
						[appCopyToClipboard]="dataAttr ? data[i][dataAttr] : data[i]"
						[appCopyToClipboardMsg]="i18nCopyToClipboardMsg"
						title="Copy to clipboard"
						i18n-title
					>
						<span class="material-icons">content_copy</span>
					</button>
				</div>
			</div>
		</ng-container>
	</app-loader-wrapper>
</div>
